import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import * as API from "../../lib/api.js";
import * as Links from "../../lib/links.js";
import { ProductTypeByValue, ProductTypes } from "../../lib/product-types.js";
import Confirm from "../Confirm/Confirm.jsx";
import ProductTypeCustomItem from "../ProductType/ProductTypeCustomItem.jsx";
import ProductTypeItem from "../ProductType/ProductTypeItem.jsx";
import BackNext from "./BackNext.jsx";
import WizardButtons from "./WizardButtons.jsx";

export default function WStepBusinessType(props) {
    const { t } = useTranslation();
    const history = useHistory();

    const {
        next,
        set,
        setShowCustom,
        variables: { ProductType },

        isTesting, //
    } = props;

    const [accountLimits, setAccountLimits] = React.useState(null);
    const [modal, setModal] = React.useState({ show: false });

    const block = !accountLimits;

    React.useEffect(() => {
        loadAccountLimits();
    }, []);

    function loadAccountLimits() {
        API.AccountLimits().then(response => setAccountLimits(response?.limits));
    }

    function onProductTypeClick(productType) {
        const { value: ProductType, variables } = productType;

        if (!isTesting) {
            if (ProductType === "ecommerce" && accountLimits?.current?.ecommerce >= accountLimits?.ecommerce) {
                setModal({ ...modal, type: "ecommerce", show: true });
                return;
            } else if (ProductType !== "ecommerce" && accountLimits?.current?.websites >= accountLimits?.websites) {
                setModal({ ...modal, type: "websites", show: true });
                return;
            }
        }

        if (ProductType === "Custom") {
            setShowCustom(true);
            set({ ProductType });
            return;
        }

        next(null, { ProductType, ...variables });
    }

    function closeModal() {
        setModal({ ...modal, show: false });
    }

    function gotoSubscriptions() {
        history.push(Links.Subscription());
    }

    const customType = ProductTypeByValue["Custom"];

    return (
        <>
            <div className="wizard-part-inner">
                <div className="grid-gap-20 align-items-center" style={{ gridTemplateRows: "max-content 1fr" }}>
                    <p>{t("WizardWStepBusinessTypeText")}</p>

                    <div>
                        {/* <ProductTypeCustomItem
                            {...customType}
                            onClick={() => onProductTypeClick(customType)}
                            disabled={block}
                        /> */}

                        <WizardButtons className="step1">
                            <input type="hidden" name="ProductType" value={ProductType ?? ""} />

                            {ProductTypes.map(productType => {
                                const { name_t, value } = productType;

                                const bProps = {
                                    value,
                                    name_t,
                                    [ProductType === value ? "solid" : "dashed"]: true,
                                    onClick: () => onProductTypeClick(productType),
                                };

                                if (value === "Custom") {
                                    return null;
                                }

                                return (
                                    <div key={value}>
                                        <ProductTypeItem {...bProps} disabled={block} />
                                    </div>
                                );
                            })}

                            <div>
                                <div className="wizard-product-item coming-soon">{t("WizardMoreTypesComingSoon")}</div>
                            </div>
                        </WizardButtons>
                    </div>
                </div>

                <BackNext {...props} next={null} generate={null} />
            </div>

            <Confirm
                show={modal?.show}
                header={t("UpgradeThePlan")}
                text={t(
                    modal?.type === "ecommerce"
                        ? "CurrentPlanDoesNotAllowYouToCreateECommerce"
                        : "CurrentPlanDoesNotAllowYouToCreateWebsites"
                )}
                actions={[
                    { onClick: () => closeModal(), text: t("Close") },
                    {
                        onClick: () => gotoSubscriptions(),
                        text: t("Subscriptions"),
                        props: { invert: true },
                    },
                ]}
            />
        </>
    );
}
